import React, { useState, useEffect } from "react";
import Profile from "../assets/profile.png";
import Bag from "../assets/svgs/bagwhite.svg";
import Cross from "../assets/svgs/cross.svg";
import Location from "../assets/svgs/locationwhite.svg";
import moment from "moment";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import Button from "../components/Button";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../components/Layout";

function Calendar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { doctor } = location.state || {}; // Get doctor details passed from the previous page
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);

    useEffect(() => {
        if (!doctor) {
            navigate("/"); // Redirect to the home page if no doctor data is provided
            return;
        }

        const fetchAvailableSlots = async () => {
            try {
                const response = await fetch(
                    `https://backend-58742455872.us-central1.run.app/api/v1/doctors/availableSlots?doctorId=${doctor.id}&date=${selectedDate}`
                );
                const data = await response.json();
                if (response.ok) {
                    setTimeSlots(data.slots);
                } else {
                    console.error("Failed to fetch slots:", data.error);
                    setTimeSlots([]);
                }
            } catch (error) {
                console.error("Error fetching available slots:", error);
                setTimeSlots([]);
            }
        };

        fetchAvailableSlots();
    }, [selectedDate, doctor, navigate]);

    const handleBook = () => {
        if (selectedSlot) {
            navigate("/fourstep", {
                state: {
                    doctorId: doctor.id,
                    doctorName: doctor.name,
                    speciality: doctor.speciality,
                    yearsOfExperience: doctor.yearsOfExperience,
                    address: doctor.address,
                    appointmentDate: selectedDate,
                    slot: selectedSlot,
                },
            });
        }
    };

    return (
        <Layout>
            <div className="container mx-auto p-6">
                <div className="flex justify-between items-center">
                    <h1 className="text-2xl font-bold text-primaryBlue90">Book Appointment</h1>
                    <button onClick={() => navigate(-1)} className="text-white p-2 px-4 rounded-full bg-orange hover:bg-gray-200">
                        {/* <img src={Cross} alt="Close" /> */}
                        back
                    </button>
                </div>

                <div className="flex flex-col  md:flex-row mt-6 gap-8">
                    <div className="md:w-1/3 bg-primaryBlue90 text-white p-6 rounded-lg">
                        <div className="w-20 h-20 md:w-44 md:h-44 rounded-full overflow-hidden mb-4">
                            <img src={doctor?.profileImage || Profile} alt="Doctor Profile" />
                        </div>
                        <h2 className="text-xl font-bold">{doctor?.name}</h2>
                        <p>{doctor?.speciality}</p>
                        <div className="mt-4">
                            <div className="flex items-center gap-2">
                                <img src={Bag} alt="Experience" />
                                <span>{doctor?.yearsOfExperience} years of experience</span>
                            </div>
                            <div className="flex  items-center gap-2 mt-2">
                                <img src={Location} alt="Location" />
                                <span>{doctor?.address}</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-10 md:flex-row bg-white p-6 rounded-lg">
                        <div>
                            <h3 className="text-lg font-semibold text-primaryBlue90">Select Date</h3>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <StaticDatePicker
                                    value={moment(selectedDate)}
                                    onChange={(newValue) => setSelectedDate(newValue.format("YYYY-MM-DD"))}
                                    sx={{
                                        ".MuiPickersDay-root": {
                                            fontFamily: "Outfit, sans-serif",
                                        },
                                        ".MuiPickersToolbar-root": {
                                            display: "none",
                                        },
                                        ".MuiDialogActions-root": {
                                            display: "none",
                                        },
                                        ".MuiButtonBase-root": {
                                            fontFamily: "Outfit, sans-serif",
                                        },
                                        ".css-4k4mmf-MuiButtonBase-root-MuiPickersDay-root.Mui-selected":
                                        {
                                            background: "#039BE5",
                                        },
                                        ".MuiDayCalendar-weekContainer": {
                                            gap: "1px",
                                            // marginTop: "1rem",
                                            // overflow: "visible",
                                        },
                                    }}
                                />

                            </LocalizationProvider>
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-primaryBlue90 mt-6">Select Time</h3>
                            <div className="flex justify-center flex-wrap gap-4 mt-4">
                                {timeSlots.map((slot) => (
                                    <TimeBox
                                        key={slot.slot}
                                        time={slot.slot}
                                        isSelected={selectedSlot === slot.slot}
                                        isAvailable={slot.isAvailable}
                                        handleClick={() => slot.isAvailable && setSelectedSlot(slot.slot)}
                                    />
                                ))}
                            </div>
                            <div className="mt-6 flex justify-end">
                                <Button text="Book Appointment" disabled={!selectedSlot} handleClick={handleBook} />
                            </div>
                        </div>


                    </div>

                </div>

            </div>
        </Layout>
    );
}

export default Calendar;

const TimeBox = ({ isSelected = false, isAvailable = true, time, handleClick }) => (
    <button
        onClick={isAvailable ? handleClick : undefined}
        className={`border py-2 px-4 text-center rounded-lg text-sm font-medium cursor-pointer ${isAvailable
            ? isSelected
                ? "bg-primaryBlue50 text-white border-primaryBlue50"
                : "text-primaryBlue90 border-neutral5 hover:border-primaryBlue90"
            : "text-neutral30 border-neutral30 cursor-not-allowed"
            }`}
    >
        {time}
    </button>
);
